import React, { useState } from 'react';
import { API } from '../utils/apiBase';

export const CamperAvatar = ({ firstName, lastName, personId, size = 40, className = '' }) => {
  const [failed, setFailed] = useState(false);
  const initials = `${(firstName || '?')[0] || '?'}${(lastName || '?')[0] || '?'}`.toUpperCase();
  const src = `${API}/summer2026/camper-photo?personId=${encodeURIComponent(personId || '')}&name=${encodeURIComponent(`${firstName || ''} ${lastName || ''}`.trim())}`;

  if (failed) {
    return (
      <div
        className={`bg-blue-100 text-blue-800 rounded-full flex items-center justify-center font-bold flex-shrink-0 ${className}`}
        style={{ width: size, height: size, fontSize: Math.max(11, size * 0.35) }}
        data-testid={`camper-avatar-initials-${personId}`}
      >
        {initials}
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={`${firstName || ''} ${lastName || ''}`}
      loading="lazy"
      onError={() => setFailed(true)}
      className={`rounded-full object-cover flex-shrink-0 bg-blue-50 ${className}`}
      style={{ width: size, height: size }}
      data-testid={`camper-avatar-${personId}`}
    />
  );
};
